var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sport === 'soccer')?_c('league-page-soccer'):_vm._e(),(_vm.sport === 'hockey')?_c('league-page-hockey'):_vm._e(),(_vm.sport === 'bsktbl')?_c('league-page-basketball'):_vm._e(),(_vm.sport === 'box')?_c('category-page-box'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }